import { useInfiniteQuery } from '@tanstack/react-query'
import { api } from '~/apiClient'
import { useMarketplace } from '../context'
import { useDebouncedValue } from '~/utils/hooks/useDebouncedValue'

interface PaginatedResponse<T> {
    results: T[]
    page: number
    total_pages: number
    total_items: number
    has_next: boolean
    has_previous: boolean
}

async function fetchCollection(
    nftType: string,
    page: number = 1,
    filters: Record<string, string[]> = {},
    search: string = null,
    sort: string = null
) {
    const queryParams = new URLSearchParams()
    Object.entries(filters).forEach(([trait, values]) => {
        queryParams.set(trait, values.join(','))
    })
    queryParams.set('page', page.toString())
    if (search) queryParams.set('search', search)
    if (sort) queryParams.set('sort', sort)
    const url = `/api/nft/marketplace/collection/${nftType}/?${queryParams.toString()}`
    return await api.get<PaginatedResponse<MarketplaceItem>>(url)
}

export function useCollection() {
    const { state } = useMarketplace()
    const debouncedState = useDebouncedValue(state, 400)
    const nftType = state.collection

    return useInfiniteQuery({
        queryKey: ['marketplace', 'collection', debouncedState],
        queryFn: ({ pageParam = 1 }) => fetchCollection(nftType, pageParam, state.filters, state.search, state.sort),
        getNextPageParam: (lastPage, allPages) => (lastPage.has_next ? lastPage.page + 1 : undefined),
        enabled: !!nftType,
        cacheTime: 0,
        keepPreviousData: true,
    })
}
